import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const contributionApi = generateNomenApi(`/nomen/contributions`);

export const contributionOptions = generateNomenOptions('contribution', contributionApi);
